import { render, staticRenderFns } from "./DefaultViewLoggedInUser.vue?vue&type=template&id=60c023cc&"
import script from "./DefaultViewLoggedInUser.vue?vue&type=script&lang=js&"
export * from "./DefaultViewLoggedInUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports